// extracted by mini-css-extract-plugin
export var deleteIcon = "_nf-5";
export var deleteOption = "_nf-3";
export var divider = "_nf-2";
export var downloadIcon = "_nf-4";
export var drawer = "_nf-0";
export var drawerFooter = "_nf-6";
export var drawerOpen = "_nf-1";
export var highlighted = "_nf-7";
export var lighterHighlight = "_nf-8";